/* eslint-disable react/prop-types */
import { h } from 'preact'

function BlockTitle({
    title,
    text,
    bordered,
    orientation,
    centeredWithDecoration,
    borderColor,
    tag,
}) {
    let classList = 'w-block-title'

    if (centeredWithDecoration) {
        return (
            <div className="w-block-title --centered-with-decoration">
                <hr style={`background: ${borderColor}`} />
                {!tag ? <h2>{title}</h2> : h(tag, {}, title)}
                <hr style={`background: ${borderColor}`} />
            </div>
        )
    }

    switch (orientation) {
        case 'center':
            classList = 'w-block-title --center'
            break

        case 'left':
            classList = 'w-block-title --left'
            break

        case 'right':
            classList = 'w-block-title --right'
            break

        default:
            classList = 'w-block-title'
    }

    return (
        <div className={classList}>
            <h2>{title}</h2>

            {text && <p>{text}</p>}
            {bordered && (
                // eslint-disable-next-line react/style-prop-object
                <hr />
            )}
        </div>
    )
}

export default BlockTitle